var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { GemElement, html } from '@mantou/gem/lib/element';
import { adoptedStyle, customElement, attribute, state } from '@mantou/gem/lib/decorators';
import { createCSSSheet, css } from '@mantou/gem/lib/utils';
import { theme, getSemanticColor } from '../lib/theme';
import { commonHandle } from '../lib/hotkeys';
import { focusStyle } from '../lib/styles';
import './tooltip';
const style = createCSSSheet(css `
  :host {
    overflow: hidden;
    text-overflow: ellipsis;
    cursor: default;
    line-height: 1.5;
    --color: initial;
    color: var(--color, inherit);
    border-radius: ${theme.normalRound};
  }
  :host(:where(:hover, :--active, [data-active])) {
    color: var(--color, ${theme.primaryColor});
    text-decoration: underline;
  }
  :host(:where(:lang(zh), :lang(ja), :lang(kr))) {
    text-underline-offset: 0.125em;
  }
`);
/**
 * @customElement dy-action-text
 */
let DuoyunActionTextElement = class DuoyunActionTextElement extends GemElement {
    constructor() {
        super();
        this.render = () => {
            return html `
      <style>
        :host([color]) {
          --color: ${getSemanticColor(this.color) || this.color};
        }
      </style>
      <dy-tooltip .content=${this.tooltip}>
        <slot></slot>
      </dy-tooltip>
    `;
        };
        this.tabIndex = 0;
        this.internals.role = 'button';
        this.addEventListener('keydown', commonHandle);
    }
};
__decorate([
    attribute
], DuoyunActionTextElement.prototype, "tooltip", void 0);
__decorate([
    attribute
], DuoyunActionTextElement.prototype, "color", void 0);
__decorate([
    state
], DuoyunActionTextElement.prototype, "active", void 0);
DuoyunActionTextElement = __decorate([
    customElement('dy-action-text'),
    adoptedStyle(style),
    adoptedStyle(focusStyle)
], DuoyunActionTextElement);
export { DuoyunActionTextElement };
//# sourceMappingURL=action-text.js.map